import React from 'react';
import { Flex, Image } from 'antd';
import { ArrowLeftIcon } from '@/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from '@/config';

interface ClientErrorProps {
  imageSrc: string;
  errorTitle: string;
  errorMessage?: string;
  hasGoLoginBtn?: boolean;
}

const Error: React.FC<ClientErrorProps> = ({
  imageSrc,
  errorTitle,
  errorMessage,
  hasGoLoginBtn,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Flex className='max-h-screen flex justify-center pt-10'>
      <Flex vertical className='items-center'>
        <Image src={imageSrc} preview={false} />
        <span className='font-bold text-lg leading-[20.88px] text-[rgb(57,57,60)] mt-[26px]'>
          {errorTitle}
        </span>
        <span className='font-normal text-sm leading-[18.2px] text-[rgb(115,123,140)] mt-2 mb-[18px]'>
          {errorMessage ?? t('sorry_something')}
        </span>
        <button
          type='button'
          className='flex items-center gap-1.5 h-10 px-5 rounded-lg bg-[rgb(237,224,74)] text-[rgb(57,57,60)] text-xs font-bold uppercase cursor-pointer hover:bg-[rgb(230,217,60)] transition-colors'
          onClick={() => navigate(hasGoLoginBtn ? ROUTE.LOGIN : '/')}
        >
          <ArrowLeftIcon />
          {hasGoLoginBtn ? t('back_to_login') : t('back_home')}
        </button>
      </Flex>
    </Flex>
  );
};

export default Error;
